export default __webpack_public_path__ + "static/media/gallery-four.73e188ea.jpg";